import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { NEXA_LOGO } from "../data/content";

const go = (id) => (e) => {
  e.preventDefault();
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
};

const defaultLinks = [["learn", "LEARN"], ["host", "HOST"], ["faq", "FAQ"]];

export const Nav = ({ links = defaultLinks, ctaId = "register", ctaLabel = "REGISTER ↗" }) => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setShow(true), 500);
    return () => clearTimeout(t);
  }, []);
  return (
    <nav
      data-testid="floating-nav"
      className={`nav-pill fixed top-5 left-1/2 -translate-x-1/2 z-50 flex items-center gap-1 pl-4 pr-1.5 py-1.5 transition-all duration-700 ${show ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-3"}`}
    >
      <Link to="/" data-testid="nav-logo-link" className="mr-2 shrink-0">
        <img src={NEXA_LOGO} alt="NEXA Lending" className="h-7 w-auto invert opacity-90" />
      </Link>
      {links.map(([id, label]) => (
        <a key={id} href={`#${id}`} onClick={go(id)} data-testid={`nav-${id}-link`}
          className="mono text-[11px] tracking-[0.15em] text-white/60 hover:text-white px-3 py-2 transition-colors hidden sm:block">
          {label}
        </a>
      ))}
      <a href={`#${ctaId}`} onClick={go(ctaId)} data-testid="nav-register-cta"
        className="mono text-[11px] tracking-[0.12em] font-bold text-white bg-[var(--accent)] hover:bg-[#5a62ff] transition-colors rounded-full px-5 py-2.5 whitespace-nowrap">
        {ctaLabel}
      </a>
    </nav>
  );
};
